<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="招聘会名称：">
            <el-input clearable v-model="filterForm.fireName" placeholder="请输入招聘会名称"></el-input>
          </el-form-item>
          <el-form-item label="企业名称：">
            <el-input clearable v-model="filterForm.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="岗位名称：">
            <el-input clearable v-model="filterForm.jobName" placeholder="请输入岗位名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="formItems2" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler" />

    <el-dialog
      title="导入提示"
      :close-on-click-modal="false"
      :visible.sync="isShowImportTip"
      :append-to-body="true"
      width="1000px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>
  </div>
</template>

<script>
import enum_shengting from '@/publicData/enum_shengting'
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
import AreaPicker from '@/components/AreaPicker_3'
// import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
      sign: 'shengting_zhaopingangwei',
      dialogTitle: '招聘会招聘岗位信息',
      fileName: 'zhaopinhuizhaopingangweixinxi',
      importTipKey: 'acb331',
      importTiplabel: '招聘会名称',
      
      enum_shengting: enum_shengting,

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },

        // { key: 'sid', label: '外部系统主键' },
        // { key: 'fid', label: '招聘会外部系统主键' },
        // { key: 'cid', label: '企业外部系统主键' },
        // { key: 'hire_id', label: '岗位外部系统主键' },
        { key: 'fireName', label: '招聘会名称', fixed: true },
        { key: 'companyName', label: '企业名称', fixed: true },
        { key: 'jobName', label: '岗位名称', fixed: true },
        { key: 'ace762', label: '是否有效' },
        { key: 'status_', label: '状态' },
        { key: 'importError', label: '失败原因' },
      ],
    }
  },
  computed: {
    importAction() {
      return this.$api.baseUrl + '/user/sync/hire/job/' + this.userInfo.areaId
    },
    formItems() {
      return [
        // { type: 'text', key: 'sid', label: '外部系统主键' },
        // { type: 'text', key: 'fid', label: '招聘会外部系统主键' },
        // { type: 'text', key: 'cid', label: '企业外部系统主键' },
        // { type: 'text', key: 'hire_id', label: '岗位外部系统主键' },
        { type: 'text', key: 'fireName', label: '招聘会名称' },
        { type: 'text', key: 'companyName', label: '企业名称' },
        { type: 'text', key: 'jobName', label: '岗位名称' },
        { type: 'select_s', key: 'ace762', label: '是否有效', options: this.enum_shengting.youxiaoxing },
        // { type: 'text', key: 'status_', label: '状态' },
        // { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
    formItems2() {
      return null
    },
    formItems_() {
      return [
        ...this.formItems,
        { type: 'text', key: 'status_', label: '状态' },
        { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
  },
  methods: {
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // console.log(result, this.selectData)
      let rData = {}
      let areaId = this.$refs.AreaPicker.findAreaId()
      let {
        id,
        fireName,
        companyName,
        jobName,
        ace762,
      } = result
      if (this.isCreate) {
        rData = {
          fireName,
          companyName,
          jobName,
          ace762,
          areaId,
        }
        // console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('新建成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList = [
          'fireName',
          'companyName',
          'jobName',
          'ace762',
          'areaId',
        ]
        mapList.forEach(x => {
          // if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          // }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
        // console.log(rData)

        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })

        // this.$api.util_modify(this.sign, rData).then(res => {
        //   if (res.data.status == 0) {
        //     this.$message.success('修改成功')
        //     this.$refs.DialogEdit.isShowDialog = false
        //     this.$refs.DialogEdit.clearHandler()
        //     this.searchHandler()
        //   } else { this._status(res.data) }
        // })
      }
    },
    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R.map(x => {
            x.status_ = ['', '未校验', '通过', '失败'][x.status]
            return x
          })
          this.pageData.total = res.data.size
          console.log(this.tableData)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    const mapList1 = ['search','create','modify','import']
    mapList1.forEach(x => {
      this.btnShow[x] = true
    })
    const mapList = ['export','delete']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>